import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=6e25e0b2&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=6e25e0b2&prod&scoped=true&lang=scss&"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=6e25e0b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e25e0b2",
  null
  
)

export default component.exports